import React, { useEffect, useRef, useState } from 'react';
import Logger from 'services/logger';

export const useGtresLoadStyles = () => {
  const iframeRef = useRef();
  const bgRef = useRef();
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    const checkIframe = () => {
      const iframe = iframeRef.current;

      if (iframe) {
        const handleLoad = () => {
          setIframeLoaded(true);
        };

        iframe.addEventListener('load', handleLoad);

        // Cleanup  listener
        return () => {
          iframe.removeEventListener('load', handleLoad);
        };
      } else {
        // // Si el iframe aún no está disponible, vuelve a intentarlo
        setTimeout(checkIframe, 100); // Reintenta en 100ms
      }
    };

    checkIframe(); // Llama a la función para verificar el iframe
  }, []);

  useEffect(
    () => {
      if (iframeLoaded) {
        const iframe = iframeRef.current;
        const background = bgRef.current;
        const doc = iframe?.contentDocument || iframe?.contentWindow?.document;

        if (doc) {
          try {
            doc.body.style.backgroundColor = 'black';
            background.style.display = "none";
          } catch (error) {
            Logger.error(error);
          }
        }
      }
    },
    [iframeLoaded],
  );


 return {
    iframeRef, bgRef
 }
}